import { render, staticRenderFns } from "./v404.vue?vue&type=template&id=775ac4ca&scoped=true"
import script from "./v404.vue?vue&type=script&lang=js"
export * from "./v404.vue?vue&type=script&lang=js"
import style0 from "./v404.vue?vue&type=style&index=0&id=775ac4ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775ac4ca",
  null
  
)

export default component.exports